import React, { useEffect, useState } from 'react';
import { IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import './Message-Create-View.scss';
import { getWelcomeMessageVariables } from '../../../../utils/ServicesAPIUtils';

const VariableKeywordsModal = ({
  isOpen,
  onClose,
  customFetcher,
  responseKey = 'listWelcomeMessageVariables',
}) => {
  const [variables, setVariables] = useState([]);

  useEffect(() => {
    const fetchVariables = async () => {
      try {
        const fetcher = customFetcher || getWelcomeMessageVariables;
        const response = await fetcher();
        const variablesList = response?.data?.[responseKey] || [];
        setVariables(variablesList);
      } catch (err) {
        console.error('Error fetching variables:', err);
      }
    };

    if (isOpen) {
      fetchVariables();
    }
  }, [isOpen, customFetcher, responseKey]);

  if (!isOpen) return null;

  return (
    <>
      <div className='modal-overlay' onClick={onClose} />
      <div className='variable-list-modal'>
        <div className='variable-header d-flex justify-content-between align-items-center'>
          <div className='ps-2'>Variable List</div>
          <IconButton aria-label='cancel' onClick={onClose}>
            <CancelIcon />
          </IconButton>
        </div>
        <div className='variable-content row  d-flex'>
          <table className='variable-table'>
            <thead>
              <tr>
                <th>Variable Type</th>
                <th>Variable Keyword</th>
              </tr>
            </thead>
            <tbody>
              {variables?.map((item, index) => (
                <tr key={index}>
                  <td>{item?.type}</td>
                  <td>{item?.keyword}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default VariableKeywordsModal;
